import Head from 'next/head';
import React from 'react';
import parse from 'html-react-parser';
import { seoUrlParser } from '../utils/helper';
import { decode } from 'html-entities';
import { parsePageSchema } from '../utils/pageSchema';

type Props = {
    seoFullHead: string;
    // Hand-authored JSON-LD (FAQ / ItemList / etc.) pasted in WordPress and
    // synced onto the page/taxonomy Typesense document. Optional/absent = render nothing.
    pageSchemaCode?: string;
};

const PageSeo = ({ seoFullHead, pageSchemaCode }: Props) => {
    const schemaBlocks = parsePageSchema(pageSchemaCode);

    return (
        <Head>
            {parse(seoUrlParser(decode(seoFullHead)))}
            {schemaBlocks.map((obj, i) => (
                <script
                    key={`page-schema-${i}`}
                    type="application/ld+json"
                    // Escape every "<" (as unicode) so a closing script tag in the data can't break out.
                    dangerouslySetInnerHTML={{
                        __html: JSON.stringify(obj).replace(/</g, '\\u003c'),
                    }}
                />
            ))}
        </Head>
    );
};

export default PageSeo;
